import { FC, ReactNode } from 'react'
import cn from 'classnames'

import styles from 'components/features/rewards/rewardPageSummary/SummarySectionPreset/SummarySectionPreset.styl'
import { Arc } from 'components/atoms/Arc/Arc'

type SummarySectionPresetProps = {
  header: ReactNode
  main: ReactNode
  footer: ReactNode
  inProgress?: boolean
  className?: string
}

export const SummarySectionPreset: FC<SummarySectionPresetProps> = ({
  header,
  main,
  footer,
  className,
  inProgress,
}) => (
  <section className={ cn(styles.container, className, inProgress && styles.inProgress) }>
    <header className={ styles.header }>
      { header }
    </header>
    <main className={ styles.main }>
      { main }
      { inProgress && (
        <div className={ styles.loading }>
          <div className={ styles.spinner }>
            <Arc className={ styles.arc } ratio={ .85 } />
          </div>
          <b>Transaction In Progress</b>
          This may take a few minutes
        </div>
      )}
    </main>
    <footer className={ styles.footer }>
      { footer }
    </footer>
  </section>
)
